import { type LocalStorageKeyInput } from './base/localStorage.key';

import useLocalStorage, { type LocalStorageOptions } from './useLocalStorage';
import useScopedKeyInput, { type ScopedKeyOptions } from './useScopedKeyInput';

type ScopedLocalStorageOptions = LocalStorageOptions & ScopedKeyOptions;

const useScopedLocalStorage = <T>(
  keyInput: LocalStorageKeyInput,
  initialValue: T,
  options?: ScopedLocalStorageOptions,
) => {
  const scopedKeyInput = useScopedKeyInput(keyInput, options);

  return useLocalStorage(scopedKeyInput, initialValue, options);
};

export default useScopedLocalStorage;
